module.exports = __webpack_public_path__ + "static/media/keyweb.2d4bf22d.svg";